<ion-header>
    <ion-toolbar #headerToolbar style="--background: var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-menu-button data-test="sidemenuButton"></ion-menu-button>  <!-- auto-hide="false"  -->
        </ion-buttons>
        <ion-title #title data-test="title">Dashboard</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        A summary of your shuttle department's activities.
    </ion-list-header>

    <div class="ion-padding">
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-card id="ticketsCard">
                        <ion-card-header> Tickets </ion-card-header>
                        <ion-card-content>
                            <canvas id="ticketsCanvas"></canvas>
                        </ion-card-content>
                    </ion-card>
                </ion-col>

                <ion-col>
                    <ion-card id="tripsCard">
                        <ion-card-header> Trips </ion-card-header>
                        <ion-card-content>
                            <canvas id="tripsCanvas"></canvas>
                        </ion-card-content>
                    </ion-card>
                </ion-col>
            </ion-row>

            <ion-row>
                <ion-col>
                    <ion-card id="customersCard">
                        <ion-card-header> Customers </ion-card-header>
                        <ion-card-content>
                            <canvas id="customersCanvas"></canvas>
                        </ion-card-content>
                    </ion-card>
                </ion-col>

                <ion-col>
                    <ion-card id="campaignsCard">
                        <ion-card-header> Campaigns </ion-card-header>
                        <ion-card-content>
                            <canvas id="campaignsCanvas"></canvas>
                        </ion-card-content>
                    </ion-card>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</ion-content>